module.exports = __webpack_public_path__ + "assets/add-icon-hover.50df40dd.svg";